<nav>
    <ul class="sm sm-ucr main-menu" [id]="id">
        <li [hidden]="(userInfo?.ifAnyGranted([roles.switchUser, roles.siteAdmin]) === false || mayEditTextComponents === false)">
            <a   href="javascript:void(0)" class="has-submenu button">Support</a>
            <ul class="sm-nowrap">
                <li [hidden]="!mayEditTextComponents"><a (click)="toggleTextEditing()">{{toggleTextEditText}}</a></li>
                <li [hidden]="userInfo?.ifAnyGranted([roles.siteAdmin]) === false"><a target="_blank" href="/quartz/list">Quartz Monitoring</a></li>
                <li [hidden]="userInfo?.ifAnyGranted([roles.siteAdmin]) === false"><a target="_blank" href="/monitoring">JavaMelody Monitoring</a></li>
                <li [hidden]="userInfo?.ifAnyGranted([roles.switchUser]) === false"><a (click)="openSwitchUserDialog()">Switch User</a></li>

            </ul>
        </li>
        <li>
            <a (click)="signOutIn()" class="button">{{ logInButtonText }}</a>
        </li>
    </ul>
</nav>
